import { render, staticRenderFns } from "./DownloadTemplates.vue?vue&type=template&id=4e9be790"
import script from "./DownloadTemplates.vue?vue&type=script&lang=js"
export * from "./DownloadTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports